import { useEffect, useState } from 'react';
import type { ArtikelAnsicht, Gesellschaft } from '@arbeitsrapporte/shared';
import { api } from '../api';

/**
 * Ein Artikel aus dem Stamm der Gesellschaft – gesucht, während man tippt.
 * Nichts gewählt heißt „frei benannt", und das ist erlaubt.
 */
export function Artikelwahl({
  gesellschaft,
  gewaehlt,
  onWahl,
}: {
  gesellschaft: Gesellschaft;
  gewaehlt: { id: string; nummer: string | null } | null;
  onWahl: (artikel: ArtikelAnsicht | null) => void;
}) {
  const [suche, setSuche] = useState('');
  const [treffer, setTreffer] = useState<ArtikelAnsicht[]>([]);
  const [offen, setOffen] = useState(false);

  useEffect(() => {
    if (!offen) return;

    const t = setTimeout(() => {
      api
        .artikel(suche, gesellschaft)
        .then(setTreffer)
        .catch(() => setTreffer([]));
    }, 200);

    return () => clearTimeout(t);
  }, [suche, gesellschaft, offen]);

  if (gewaehlt) {
    return (
      <span className="flex min-h-11 items-center gap-2 rounded border border-slate-300 bg-slate-50 px-3 text-sm">
        <span className="truncate text-slate-700">
          Artikel {gewaehlt.nummer ?? '(ohne Nummer)'}
        </span>
        <button
          type="button"
          aria-label="Artikel entfernen"
          onClick={() => onWahl(null)}
          className="ml-auto min-h-0 shrink-0 rounded px-2 py-1 text-slate-500 hover:bg-slate-200 hover:text-slate-900"
        >
          ✕
        </button>
      </span>
    );
  }

  return (
    <span className="relative block">
      <input
        className="feld"
        placeholder="Artikel suchen …"
        value={suche}
        onFocus={() => setOffen(true)}
        onChange={(e) => setSuche(e.target.value)}
      />
      {offen && treffer.length > 0 && (
        <ul className="absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded border border-slate-200 bg-white py-1 shadow-lg">
          {treffer.map((a) => (
            <li key={a.id}>
              <button
                type="button"
                onClick={() => {
                  onWahl(a);
                  setOffen(false);
                }}
                className="flex min-h-11 w-full items-center gap-2 px-3 text-left text-sm hover:bg-slate-100"
              >
                <span className="font-medium text-slate-900">{a.nummer || '–'}</span>
                <span className="truncate text-slate-700">{a.bezeichnung}</span>
                <span className="ml-auto shrink-0 text-xs text-slate-500">{a.einheit}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </span>
  );
}
